import { render, staticRenderFns } from "./CarAppoint.vue?vue&type=template&id=57472c22&scoped=true&"
import script from "./CarAppoint.vue?vue&type=script&lang=js&"
export * from "./CarAppoint.vue?vue&type=script&lang=js&"
import style0 from "./CarAppoint.vue?vue&type=style&index=0&id=57472c22&lang=less&scoped=true&"
import style1 from "./CarAppoint.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57472c22",
  null
  
)

export default component.exports